module.exports = __webpack_public_path__ + "img/getnet.187430d6.svg";